import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "../catalogs.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { faAngleRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'react-resizable/css/styles.css';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import { apiService } from '../../../../services/apiService';
import { toast } from 'react-toastify';
import GeneralCaseCats from '../../../../components/catalog/GeneralCaseCats';
import GeneralCaseKnowledge from './BasicTabs/GeneralCaseKnowledge';
import GeneralCaseApprovalHistory from './BasicTabs/GeneralCaseApprovalHistory';
import CaseAllDetails from './BasicCaseTabs/CaseAllDetails';
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import DiscussTaskCase from './BasicTabs/DiscussTaskCase';

function PartnerStep() {
    const navigate = useNavigate();
    const location = useLocation();
    const [expanded, setExpanded] = useState(true);
    const parts_location = location.pathname.split("/");
    const caseSlug = parts_location[2] || null;
    const caseId = parts_location[4] || null;
    const [reloadChild, setReloadChild] = useState(0);
    const [activeTab, setActiveTab] = useState("overview");
    const [activeTabCase, setActiveTabCase] = useState("task");
    const [showCase, setShowCase] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const handleCloseSuccess = () => setShowSuccess(false);
    const [formData, setFormData] = useState({
        Q0200: '',
        Q0210: '',
    });
    const [errors, setErrors] = useState({});
    const [errorMessage, setErrorMessage] = useState('');
    const [submitloader, setSubmitloader] = useState(false);

    
    const [loading, setLoading] = useState(false);
    const [allData, setAllData] = useState([]);
    const [refetchData, setRefetchData] = useState(null);

    const [showRejecters, setShowRejecters] = useState(false);
    const handleCloseRejecters = () => setShowRejecters(false);
    const [showApproval, setShowApproval] = useState(false);
    const handleCloseApprovals = () => setShowApproval(false);
    const [showRefBack, setShowRefBack] = useState(false);
    const handleCloseRefBack = () => setShowRefBack(false);
    // const [paginatedata, setPaginateData] = useState({});
    // const [currentPage, setCurrentPage] = useState(1);
    const fetchFormData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiService.getRequest(`/cases/${caseSlug}/${caseId}`);
            if (response && response.success === true) {
                setAllData(response.data);
                setShowCase(response.data?.can_see_case);
                setRefetchData(response.data.inprogress_form_data);
            }else{
                if(response.error === "permission_denied"){
                    toast.error(response.message || "Permission Denied")
                    navigate("/dashboard")
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [caseSlug, caseId, navigate]);

    useEffect(() => {
        fetchFormData();
    }, [fetchFormData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
    
        // Clear the error for the specific field being modified
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
        setFormData({ ...formData, [name]: value });
    };
    
    const validateForm = (action) => {
        const newErrors = {};
        if(action === "reject"){
            if (!formData.Q0200) newErrors.Q0200 = "Reason  is required.";
            if (formData.Q0200 && formData.Q0200.length < 10) {
                newErrors.Q0200 = "Reason must be at least 10 characters long.";
            }else if (formData.Q0200 && formData.Q0200.length > 4000) {
                newErrors.Q0200 = 'Reason be less than 4000 characters long.';
            }
        }
        if(action === "refer_back"){
            if (!formData.Q0210) newErrors.Q0210 = "Reason  is required.";
            if (formData.Q0210 && formData.Q0210.length < 10) {
                newErrors.Q0210 = "Reason must be at least 10 characters long.";
            }else if (formData.Q0210 && formData.Q0210.length > 4000) {
                newErrors.Q0210 = 'Reason be less than 4000 characters long.';
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e, action, Q0190) => {
        e.preventDefault();
        if (!validateForm(Q0190)) {
            setErrorMessage('Please fix the errors before proceeding.');
            return;
        }
        setSubmitloader(true);
        try {
            // const formDataToSend = new FormData();

            // // Add other form fields
            // for (const key in formData) {
            //     if (formData[key] !== undefined && formData[key] !== null) {
            //         formDataToSend.append(key, formData[key]);
            //     }
            // }
            const jsonParams = {
                ...formData,
                action,
                Q0190,
            };
            const response = await apiService.postRequest(`cases/${caseSlug}/${caseId}/submit`, jsonParams);

            // Check if the response indicates success
            if (response && response.success === true) {
                if(action === "refer_back"){
                    toast(response.message || "Submitted Successfully !");
                    navigate("/task/my-cases");
                }else{
                    setShowRejecters(false);
                    setShowApproval(false);
                    setShowSuccess(true);
                    setErrors({});
                    setErrorMessage('');
                    fetchFormData();
                    setReloadChild(prev => prev + 1);
                    toast(response.message || "Submitted Successfully !")
                }
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
            }
        } catch (error) {
            console.log("err",error);
        }finally {
            setSubmitloader(false); // Stop loader
        }
    };
    const sanitizeAndDisplayHTML = (html) => {
        if (!html) return '';
        const formattedHTML = html.replace(/\r\n|\r|\n/g, '<br />');
        return formattedHTML;
    };
  return (
    <div className='container-fluid px-0'>
        <div className="resizable-container d-flex">
            <GeneralCaseCats onReload={reloadChild}/>
            <div className='content_container_validate' style={{ flexGrow: 1 }}>
                <Grid size={{md:8,xs:12}} container flexDirection="column" className="jobseekerhead mb-3">
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> 
                        <FontAwesomeIcon className='angleright' icon={faAngleRight} /> 
                        <b className="formatid_copyclip fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                            onClick={async () => {
                                const url = `${window.location.origin}${allData?.case?.case_task_link}`;
                                const title = allData?.case?.gcase_summary?.short_description || "Case";
                                const textPlain = `${allData?.case?.case_formatted_id}: ${title}\n${url}`;
                                const textHtml = `<a href="${url}" target="_blank">${allData.case?.case_formatted_id}: ${title}</a>`;
                                try {
                                await navigator.clipboard.write([
                                    new ClipboardItem({
                                    "text/html": new Blob([textHtml], { type: "text/html" }),
                                    "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                    }),
                                ]);
                                toast("Link copied to clipboard");
                                } catch (err) {
                                console.error("Failed to copy: ", err);
                                toast("Failed to copy link");
                                }
                            }}
                            >
                            {allData?.case?.case_formatted_id}
                        </b>
                        <FontAwesomeIcon className='angleright' icon={faAngleRight} />
                        <b className="formatid_copyclip fw-bold text-decoration-none" style={{color:"#1A5298", width:"max-content"}}
                            onClick={async () => {
                                const url = `${window.location.origin}${allData?.case?.case_task_link}`;
                                const title = allData?.case?.gcase_summary?.short_description || "Case";
                                const textPlain = `${allData?.task?.task_format_id} - ${allData?.case?.case_formatted_id}: ${title}\n${url}`;
                                const textHtml = `<a href="${url}" target="_blank">${allData?.task?.task_format_id} - ${allData.case?.case_formatted_id}: ${title}</a>`;
                                try {
                                await navigator.clipboard.write([
                                    new ClipboardItem({
                                    "text/html": new Blob([textHtml], { type: "text/html" }),
                                    "text/plain": new Blob([textPlain], { type: "text/plain" }),
                                    }),
                                ]);
                                toast("Link copied to clipboard");
                                } catch (err) {
                                console.error("Failed to copy: ", err);
                                toast("Failed to copy link");
                                }
                            }}
                            >
                            {allData?.task?.task_format_id}
                        </b>
                        </span>
                </Grid>
                <Grid size={{sm:12}} container className="main_jobseeker tab_controllers">
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :
                        <Grid size={{sm:12}} container justifyContent="space-between">
                            <Grid size={{ lg: expanded ? 7.4 : 11.5, md: expanded ? 7 : 11, xs: 12 }} sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)" }} container alignContent="flex-start">
                            <Tabs
                                activeKey={activeTabCase}
                                onSelect={(key) => setActiveTabCase(key)}
                                defaultActiveKey="task"
                                id="uncontrolled-tab-example" className="mb-4 drafttabs_tabs"
                            >
                                <Tab eventKey="task" title="Task">
                                    <Grid size={{xs:12}} container justifyContent="space-between" className="jobseekerhead border_botomer mario_fixers">
                                        <Grid container flexDirection="column">
                                            <h3>Partner Voice Approval<small className='small_headingstatuses'>{allData?.task?.status}</small></h3>
                                            <span>General Case</span>
                                        </Grid>
                                    </Grid>
                                    <Grid size={{sm:12}} container>
                                        <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className={`tab_controllers ${ expanded && "control_splits"}`}>
                                            <Tabs
                                                activeKey={activeTab}
                                                onSelect={(key) => setActiveTab(key)}
                                                defaultActiveKey="overview"
                                                id="uncontrolled-tab-example" className="drafttabs_tabs mt-4"
                                                >
                                                <Tab eventKey="overview" title="Overview" className={`${ expanded && "expanded-grid"}`}>
                                                    
                                                    <Grid size={{sm:12}} container alignItems="center">
                                                        <Grid size={{lg:12,xs:12}} container justifyContent="space-between" className="regiter_inputs i94validateinput">
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Requested By<small className='red_starimpo'>*</small></span>
                                                                <p>{allData?.case?.requested_by_name}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Requested For<small className='red_starimpo'>*</small></span>
                                                                <p>{allData?.case?.requested_for_name}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Re-assignment Count <span style={{color:"red"}}> *</span></span>
                                                                <p> {allData?.case?.reassignment_count} </p>
                                                            </Grid>
                                                            <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Impact <span style={{color:"red"}}> *</span></span>
                                                                <p> {allData?.inprogress_form_data?.Q0010?.display_value} </p>
                                                            </Grid>
                                                            {allData?.inprogress_form_data?.Q0020?.display_value &&
                                                            <Grid size={{md:5.5, sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Location</span>
                                                                <p> {allData?.inprogress_form_data?.Q0020?.display_value} </p>
                                                            </Grid>}
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Solution<span style={{color:"red"}}> *</span></span>
                                                                <p>{allData?.senior_partner_form_data?.Q0040?.display_value || refetchData?.Q0040?.display_value}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Case Type<span style={{color:"red"}}> *</span></span>
                                                                <p>{allData?.senior_partner_form_data?.Q0050?.display_value || refetchData?.Q0050?.display_value}</p>
                                                            </Grid> 
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Case Sub Type<span style={{color:"red"}}> *</span></span>
                                                                <p>{allData?.senior_partner_form_data?.Q0060?.display_value || refetchData?.Q0060?.display_value}</p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Due Date<span style={{color:"red"}}> *</span></span>
                                                                <p>{allData?.senior_partner_form_data?.Q0080?.display_value || refetchData?.Q0080?.display_value} </p>
                                                            </Grid>
                                                            <Grid size={{md:5.5,sm:5.8, xs:12}} container flexDirection="column">
                                                                <span>Resolution Code<span style={{color:"red"}}> *</span></span>
                                                                <p>{allData?.senior_partner_form_data?.Q0090?.display_value || refetchData?.Q0090?.display_value}</p>
                                                            </Grid>
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Resolution Notes</span>
                                                                <p className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(refetchData?.Q0100?.display_value || "No Data") }} />
                                                            </Grid>
                                                            {refetchData?.Q0110?.display_value &&
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Private Work Notes</span>
                                                                <p className='w-100' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(refetchData?.Q0110?.display_value || "No Data") }} />
                                                            </Grid>}
                                                            {refetchData?.Q0120?.display_value?.length > 0 &&
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Attachments</span>
                                                                <Grid size={{xs:12}} container justifyContent="space-between">
                                                                    {refetchData?.Q0120?.display_value.map((file, index) => (
                                                                        <span className='mt-2' key={index}>{index +1}. <Link to={`${file}`} target='_blank'>View</Link></span>
                                                                    ))}
                                                                </Grid>
                                                            </Grid>}
                                                            {allData?.senior_partner_form_data?.Q0130?.display_value && Array.isArray(allData?.senior_partner_form_data.Q0130.display_value) && allData?.senior_partner_form_data.Q0130.display_value.length > 0 ?
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Related Knowledge Articles</span>
                                                                {allData?.senior_partner_form_data?.Q0130?.display_value.map((tag, index) => (
                                                                        <p className='mb-1 mt-0' key={index}>{tag}</p>
                                                                    ))
                                                                }
                                                            </Grid> :
                                                            refetchData?.Q0130?.display_value && Array.isArray(refetchData.Q0130.display_value) && refetchData?.Q0130.display_value.length > 0 &&
                                                            <Grid size={{xs:12}} container flexDirection="column">
                                                                <span>Related Knowledge Articles</span>
                                                                {refetchData?.Q0130?.display_value.map((tag, index) => (
                                                                        <p className='mb-1 mt-0' key={index}>{tag}</p>
                                                                    ))
                                                                }
                                                            </Grid>}
                                                            {errorMessage && <div style={{ color: 'red', margin: '10px 0px' }}>{errorMessage}</div>}
                                                            {allData && allData.can_approve_or_reject === true &&
                                                                <Grid size={{sm:12, xs:12}} container className="mt-2 consplit_btns gap-3">
                                                                    <button type="button" onClick={() => setShowRefBack(true)} className='registersendbtn1'>Refer Back</button>
                                                                    <button type="button" onClick={() => setShowRejecters(true)} className='registersendbtn1'>Reject</button>
                                                                    <button type="button" className='registersendbtn2' onClick={() => setShowApproval(true)} >Approve</button>
                                                                </Grid>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                </Tab>
                                                <Tab eventKey="assignment" title="Approver History">
                                                    {activeTab === "assignment" && <GeneralCaseApprovalHistory />}
                                                </Tab>
                                                <Tab eventKey="knowledge" title="Knowledge">
                                                    {activeTab === "knowledge" && <GeneralCaseKnowledge />}
                                                </Tab>
                                            </Tabs>

                                            <Modal
                                                show={showRejecters} 
                                                onHide={handleCloseRejecters}
                                                size="md"
                                                aria-labelledby="contained-modal-title-vcenter"
                                                centered
                                                >
                                                <Modal.Header closeButton style={{border:"none"}}>
                                                    <h5 className='modal_pinkheader'>Reject notes</h5>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <form className='d-flex flex-column roleback_mainmodal'>
                                                        <div className='d-flex flex-column rollback_textarea'>
                                                            <span className='mt-0'>Enter a reason to reject <small className='justify_astrickt'>*</small></span>
                                                            <textarea maxLength={4001} minLength={3} name='Q0200' value={formData.Q0200} onChange={handleInputChange}/>
                                                            {errors.Q0200 && <p style={{color:"Red"}}>{errors.Q0200}</p>}
                                                            {errorMessage && <p style={{ color: 'red', margin: '10px 0px' }}>{errorMessage}</p>}
                                                        </div>
                                                        <div className='d-flex justify-content-end'>
                                                            <button type='submit' className='registersendbtn2 mb-2 ' onClick={(e) => handleSubmit(e, "reject", "Rejected")}>
                                                                {submitloader ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'}
                                                            </button>
                                                        </div>
                                                    </form>
                                                </Modal.Body>
                                            </Modal>
                                            <Modal
                                                show={showApproval} 
                                                onHide={handleCloseApprovals}
                                                size="md"
                                                aria-labelledby="contained-modal-title-vcenter"
                                                centered
                                                >
                                                <Modal.Header closeButton style={{border:"none"}}>
                                                    <h5 className='modal_pinkheader'>Approval notes</h5>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <form className='d-flex flex-column roleback_mainmodal'>
                                                        <div className='d-flex flex-column rollback_textarea'>
                                                            <span className='mt-0'>Enter a reason to approval</span>
                                                            <textarea maxLength={4001} minLength={3} name='Q0200' value={formData.Q0200} onChange={handleInputChange}/>
                                                            {errors.Q0200 && <p style={{color:"Red"}}>{errors.Q0200}</p>}
                                                            {errorMessage && <p style={{ color: 'red', margin: '10px 0px' }}>{errorMessage}</p>}
                                                        </div>
                                                        <div className='d-flex justify-content-end'>
                                                            <button type='submit' className='registersendbtn2 mb-2 ' onClick={(e) => handleSubmit(e, "approve", "Approved")}>
                                                                {submitloader ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'}
                                                            </button>
                                                        </div>
                                                    </form>
                                                </Modal.Body>
                                            </Modal>
                                            <Modal
                                                show={showRefBack} 
                                                onHide={handleCloseRefBack}
                                                size="md"
                                                aria-labelledby="contained-modal-title-vcenter"
                                                centered
                                                >
                                                <Modal.Header closeButton style={{border:"none"}}>
                                                    <h5 className='modal_pinkheader'>Refer Back</h5>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <form className='d-flex flex-column roleback_mainmodal'>
                                                        <div className='d-flex flex-column rollback_textarea'>
                                                            <span className='mt-0'>Enter a reason to Refer Back <small className='justify_astrickt'>*</small></span>
                                                            <textarea maxLength={4001} name='Q0210' value={formData.Q0210} onChange={handleInputChange}/>
                                                            {errors.Q0210 && <p style={{color:"Red"}}>{errors.Q0210}</p>}
                                                            {errorMessage && <p style={{ color: 'red', margin: '10px 0px' }}>{errorMessage}</p>}
                                                        </div>
                                                        <div className='d-flex justify-content-end'>
                                                            <button type='submit' className='registersendbtn2 mb-2 ' onClick={(e) => handleSubmit(e, "refer_back", "Refered Back")}>
                                                                {submitloader ? <img src={require('../../../../assets/whiteloader.gif')} alt=''/> : 'Submit'}
                                                            </button>
                                                        </div>
                                                    </form>
                                                </Modal.Body>
                                            </Modal>
                                        </Grid>
                                    </Grid>
                                </Tab>
                                {showCase && 
                                <Tab eventKey="case" title="Case">
                                    {activeTabCase === "case" && <CaseAllDetails expanded={expanded}/>}
                                </Tab>
                                }
                            </Tabs>
                            </Grid>
                            <Grid alignContent="flex-start" size={{ lg: expanded ? 4.4 : 0.5, md: expanded ? 4.8 : 0.4, xs: 12, }} container className="border-start ps-3" sx={{ transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)", overflow: "hidden", minWidth: expanded ? undefined : 0, }}>
                                <button onClick={() => setExpanded((prev) => !prev)} className='main_expanddisbtn'>
                                    {expanded ? <FontAwesomeIcon icon={faChevronRight} /> : <FontAwesomeIcon icon={faChevronLeft} />}
                                </button>
                                <Grid size={{xs:12}} container className={ expanded ? "" : "d-none"}>
                                    <DiscussTaskCase showCase={showCase} casediscuss={allData?.case?.is_requester}/>
                                </Grid>
                            </Grid>
                        </Grid>}
                </Grid>
                <Modal
                    show={showSuccess} 
                    onHide={handleCloseSuccess}
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    >
                    <Modal.Header closeButton style={{border:"none"}}>
                        
                    </Modal.Header>
                    <Modal.Body>
                        <div className='d-flex w-100 text-center flex-column align-items-center modal_register'>
                            <FontAwesomeIcon className='main_tickiconpopup' icon={faCircleCheck} />
                            <h3>Successfully!</h3>
                            <small>Partner Voice Approval updated successfully.</small>
                            <button onClick={handleCloseSuccess}>OK</button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    </div>
  )
}

export default PartnerStep
